(function (document, Drupal) {

    'use strict';

    Drupal.drimage = {};

    Drupal.drimage.webp = null;

    function checkWebp() {
      // Prevent this function from running if the info is already available.
      if (Drupal.drimage.webp !== null) {
        return;
      }
      // @see: https://developers.google.com/speed/webp/faq#how_can_i_detect_browser_support_for_webp
      var img = new Image();
      img.onload = function () {
        Drupal.drimage.webp = (img.width > 0) && (img.height > 0);
      };
      img.onerror = function () {
        Drupal.drimage.webp = false;
      };
      img.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
    };

    function findDelayParent(el) {
      if (el.parentNode === null) {
        return null;
      }
      if (el.parentNode.classList && el.parentNode.classList.contains('js-delay-drimage')) {
        return el.parentNode;
      }
      return findDelayParent(el.parentNode);
    };

  function findParentFigcaption(el) {
    const figure = el.parentNode.parentNode.parentNode;
    if (figure.tagName === 'FIGURE') {
      var children = figure.children;
      for(var i=0; i<children.length; i++) {
        var child = children[i];
        if (child.tagName === 'FIGCAPTION') {
          return child;
        }
      }
      return null;
    }
    return null;
  };

      function resizeFunc(size, r, d) {
        if (size[d] === 0) {
          return size;
      };

        // Clone values into new array.
        var new_size = {
          0: size[0],
          1: size[1]
        };
        new_size[d] = r;

        var inverse_d = Math.abs(d - 1);
        if (size[inverse_d] === 0) {
          return new_size;
        }
        new_size[inverse_d] = 2*Math.ceil(Math.round(new_size[inverse_d] * (new_size[d] / size[d]))/2);

        return new_size;
      };

      function fetchData(el) {
        var data = JSON.parse(el.getAttribute('data-drimage'));
        data.upscale = parseInt(data.upscale);
        data.downscale = parseInt(data.downscale);
        data.threshold = parseInt(data.threshold);
        return data;
      };

      function sizeFunc(el) {
        if (el.offsetWidth === 0) {
          return { 0: 0, 1: 0 };
      }

      var data = fetchData(el);
      var size = {
        0: el.offsetWidth,
        1: 0
      };

      // Set height for aspect ratio crop.
      if (data.image_handling === 'aspect_ratio') {
        size[1] = size[0] / data.aspect_ratio.width * data.aspect_ratio.height;
      }

      // Fix blurry images when using background cover option.
      if (data.image_handling === 'background' && data.background.size === 'cover') {
        // Example: available space = 200w, 700h, original image = 1600w, 900h
        // It would be scaled to a 200w, 112h and then be stretched to 700h
        // Calculate what height we would get by using the width of the container.
        // If that calculated height is less then the container height,
        // we need to resize our width to at least that height-ratio.
        var img = el.querySelectorAll('img');
        if (img.length > 0) {
          var width = parseInt(img[0].getAttribute('width'));
          var height = parseInt(img[0].getAttribute('height'));
          var calculated_height = height / width * size[0];
          if (calculated_height < el.offsetHeight) {
            size[0] = size[0] / calculated_height * el.offsetHeight;
          }
        }
      }

      // Get the screen multiplier to deliver higher quality images.
      var multiplier = 1;
      if (data.multiplier === 1) {
        multiplier = Number(window.devicePixelRatio);
        if (isNaN(multiplier) === true || multiplier <= 0) {
          multiplier = 1;
        }
      }
      size[0] = Math.round(size[0] * multiplier);
      size[1] = Math.round(size[1] * multiplier);

      // Make sure the requested image isn't to small.
      if (size[0] < data.upscale) {
        size = resizeFunc(size, data.upscale, 0);
      }

      // Reduce all widths to a multiplier of the threshold, starting at the
      // minimal upscaling.
      var w = size[0] - data.upscale;

      var r = (Math.ceil(w / data.threshold) * data.threshold) + data.upscale;
      // When the multiplier is > 1 we can use a slightly smaller image style as
      // long as the resulting width is at least the original un-multiplied width.
      if (multiplier > 1) {
        var r_alt = (Math.floor(w / data.threshold) * data.threshold) + data.upscale;
        if (r_alt >= size[0] / multiplier) {
          r = r_alt;
        }
      }
      size = resizeFunc(size, r, 0);

      // Downscale the image if it is to large.
      if (size[0] > data.downscale) {
        size = resizeFunc(size, data.downscale, 0);
      }

      return size;
    };

    function ratio(width, height) {
      var a = width;
      var b = height;
      while (b) {
        var t = b;
        b = a % b;
        a = t;
      }
      return (width / a) + ':' + (height / a);
    };

    /**
     * The Optimizer URL of an image for a size, as wgl_cdn builds it in PHP:
     * the parameters of the base (data.optimizer, or data.optimizer_avif with
     * format and AVIF quality) plus width and crop,
     * sorted by name and encoded as PHP's rawurlencode() (16%3A9), so the
     * eager srcset and this script share the same variants and the zone's
     * edge rules accept them.
     */
    function optimizerUrl(base, data, size) {
      var parts = base.split('?');
      var params = {};
      (parts[1] || '').split('&').forEach(function (pair) {
        if (pair) {
          var kv = pair.split('=');
          params[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1] || '');
        }
      });
      params.width = size[0];
      if (data.image_handling === 'aspect_ratio') {
        params.aspect_ratio = ratio(Number(data.aspect_ratio.width), Number(data.aspect_ratio.height));
      }
      return parts[0] + '?' + Object.keys(params).sort().map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      }).join('&');
    };

    /**
     * Whether a URL is an Optimizer variant of wgl_cdn (quality and version).
     */
    function isOptimizerUrl(url) {
      return /[?&]quality=\d+/.test(url || '') && /[?&]v=\d+/.test(url || '');
    };

    /**
     * The drimage URL of a lazy image for its current size.
     */
    function drimageUrl(data, width, height) {
      return data.subdir + '/drimage/' + width + '/' + height + '/' + data.fid + '/-' + (data.path || data.original_source);
    };

    /**
     * Fallback when an Optimizer variant fails to load (the zone refused it,
     * or the Optimizer is down): the image switches to its drimage URL, the
     * eager image to the drimage srcset rendered next to it, any other image
     * to its original. The <source> elements go, so the browser does not pick
     * the failing variant again. Error events do not bubble, so the listener
     * captures them on the document. The wrapper of a lazy image is marked
     * too, so a later resize keeps it on drimage. The search app's listener
     * (optimizerImage.ts) hands lazy images to this function.
     */
    function onImageError(event) {
      var img = event.target;
      if (!img || img.tagName !== 'IMG' || img.hasAttribute('data-wgl-fallback') || !isOptimizerUrl(img.currentSrc || img.src)) {
        return;
      }
      img.setAttribute('data-wgl-fallback', '1');
      var picture = img.parentNode && img.parentNode.tagName === 'PICTURE' ? img.parentNode : null;
      if (picture) {
        Array.prototype.forEach.call(picture.querySelectorAll('source'), function (source) {
          source.parentNode.removeChild(source);
        });
      }
      var wrapper = img.closest ? img.closest('.drimage[data-drimage]') : null;
      var src = img.getAttribute('data-wgl-fallback-src');
      var srcset = img.getAttribute('data-wgl-fallback-srcset');
      if (wrapper) {
        wrapper.setAttribute('data-wgl-fallback', '1');
      }
      if (!src && wrapper) {
        src = drimageUrl(fetchData(wrapper), Number(wrapper.getAttribute('data-w')), Number(wrapper.getAttribute('data-h'))) + '.webp';
      }
      if (srcset) {
        img.setAttribute('srcset', srcset);
      }
      else {
        img.removeAttribute('srcset');
      }
      img.src = src || (img.currentSrc || img.src).split('?')[0];
    };

    /**
     * The images that failed before the listener was installed and are still
     * broken. The first image of a page (the eager image) is in the HTML, so
     * its variant can be refused while the page is still parsed, before this
     * behaviour attaches: the inline script at the top of html.html.twig
     * records every image that fails (window.wglFailedImages), and a page
     * without it (cached from before) still has the eager image, the only one
     * with data-wgl-fallback-*. Lazy images, which may not have loaded yet,
     * are left to their own error event. The search app does the same
     * (optimizerImage.ts failedImages()).
     */
    function failedImages() {
      var recorded = Array.isArray(window.wglFailedImages) ? window.wglFailedImages : [];
      var candidates = recorded.concat(Array.prototype.slice.call(document.querySelectorAll('img[data-wgl-fallback-src], img[data-wgl-fallback-srcset]')));
      return candidates.filter(function (img, i) {
        return img && img.tagName === 'IMG' && candidates.indexOf(img) === i && img.complete && img.naturalWidth === 0;
      });
    };

    Drupal.drimage.onImageError = onImageError;
    Drupal.drimage.optimizerUrl = optimizerUrl;

    function initFunc(context) {
      if (typeof context === 'undefined') {
        context = document;
      }
      const el = context.querySelectorAll('.drimage[data-drimage]:not(.is-loading)');
      if (el.length > 0) {
        for (var i = 0; i < el.length; i++) {
          var data = fetchData(el[i]);
          // Setup some properties for images that will have a fixed aspect ratio:
          if (data.image_handling === 'aspect_ratio') {
            var img = el[i].querySelectorAll('img');
            if (img.length > 0) {
              var width = parseInt(img[0].getAttribute('width'));
              var height = width / data.aspect_ratio.width * data.aspect_ratio.height;
              img[0].setAttribute('height', height);
            }
          }

          renderEl(el[i]);

          // Setup some properties for images that will render as backgrounds.
          // set class on wrapper (+css properties that are configurable)
          if (data.image_handling === 'background') {
            if (!el[i].classList.contains('is-background-image')) {
              el[i].style.backgroundAttachment = data.background.attachment;
              el[i].style.backgroundPosition = data.background.position;
              el[i].style.backgroundSize = data.background.size;
              el[i].classList.add('is-background-image');
            }
          }
        }
      }
    };

    function renderEl(el) {
      var delay = findDelayParent(el);
      if (delay === null) {
        var rect = el.getBoundingClientRect();
        var data = fetchData(el);
        if ((rect.top + data.lazy_offset >= 0 && rect.top - data.lazy_offset <= (window.innerHeight || document.documentElement.clientHeight))
          || (rect.bottom + data.lazy_offset >= 0 && rect.bottom - data.lazy_offset <= (window.innerHeight || document.documentElement.clientHeight))) {
          if (isNaN(data.fid) === false && data.fid % 1 === 0 && Number(data.fid) > 0) {
            var size = sizeFunc(el);
            var w = Number(el.getAttribute('data-w'));
            var h = Number(el.getAttribute('data-h'));
            if (size[0] !== w || size[1] !== h) {
              if (size[0] > 0) {
                el.classList.add('is-loading');

                // add credit to figcaption
                var figcaption = findParentFigcaption(el);
                if (figcaption && data.credit) {
                  var credit = document.createElement('span');
                  credit.innerText = ' © ' + data.credit;
                  figcaption.appendChild(credit);
                }

                el.setAttribute('data-w', size[0]);
                el.setAttribute('data-h', size[1]);

                // Extra parameter with a "-" value as default to indicate we do
                // not want to use image_widget_crop integration by default.
                var iwc = '-';
                if (data.image_handling === 'iwc') {
                  iwc = data.iwc.image_style;
                }

                if (data.optimizer && !el.hasAttribute('data-wgl-fallback') && !el.querySelector('img[data-wgl-fallback]')) {
                  // Image from the Optimizer: the img gets WebP or JPEG
                  // (negotiated by the pull zone), the AVIF source AVIF.
                  const variantUrl = optimizerUrl(data.optimizer, data, size);
                  if (data.image_handling === 'background') {
                    el.style.backgroundImage = 'url("' + variantUrl + '")';
                  }
                  else {
                    var avif = el.querySelector('source[data-format="avif"]');
                    if (avif && data.optimizer_avif) {
                      avif.setAttribute('srcset', optimizerUrl(data.optimizer_avif, data, size));
                    }
                    el.querySelector('img').src = variantUrl;
                  }
                }
                else {
                const imgUrl = data.subdir + '/drimage/' + size[0] + '/' + size[1] + '/' + data.fid + '/' + iwc + (data.path || data.original_source);
                if (data.image_handling === 'background') {
                  if (Drupal.drimage.webp === true) {
                    el.style.backgroundImage = 'url("' + imgUrl + '.webp")';
                  }
                  else {
                    el.style.backgroundImage = 'url("' + imgUrl + '")';
                  }
                }
                else {
                  if (data.imageapi_optimize_webp) {
                    var source = el.querySelector('source[data-format="webp"]');
                    if (source) {
                      source.setAttribute('srcset', imgUrl + '.webp');
                    }
                  }
                  var img = el.querySelector('img');
                  img.src = imgUrl;
                }
                }


                setTimeout(function() {
                  el.classList.remove('is-loading');
                }, 1000);
              }
            }
          }
        }

      }
    };

    Drupal.behaviors.drimage = {
      attach: function (context) {
        // The webp check (for backgrounds only) is async.
        // The current JS is not written to properly handle async/promises.
        // So we will have to rely on the small timeout on the init function below.
        // If the delay is not enough, the script will simply render jpg/png instead of webp.
        // This is not what it should do, but it is acceptable until we can do a rewrite of the JS.
        checkWebp();

        if (!Drupal.drimage.errorListener) {
          Drupal.drimage.errorListener = true;
          document.addEventListener('error', onImageError, true);
          failedImages().forEach(function (img) {
            onImageError({ target: img });
          });
        }

        // Always update entire document.
        // Other elements on the page might have changed the DOM and we need to force reload our lazyloader calculations.
        // Set a small timeout so lots of concurrent behaviour triggers don't case to much load.
        var timer;
        clearTimeout(timer);
        timer = setTimeout(initFunc, 5, document);

        addEventListener('resize', function () {
          clearTimeout(timer);
          timer = setTimeout(initFunc, 100);
        });

        addEventListener('scroll', function () {
          initFunc(document);
        });
      }
    };

  })(document, Drupal);
